import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import utils from 'utils';

export default function useActionOnAtCopy() {
  const { t } = useTranslation();

  return useCallback(
    (translationKey: string, date: Date | string) =>
      t(translationKey, {
        date: utils.dateFormat(new Date(date)),
        time: utils.dateFormat(new Date(date), 'hh:MM TT'),
      }),
    [t],
  );
}
